import { AggregatedLineItemGroup } from 'CreditNotes/types'

export function removeUnselectedLineItems(
  lineItemGroup: AggregatedLineItemGroup
) {
  return {
    ...lineItemGroup,
    lineItems: lineItemGroup.lineItems.filter(item => item.selected)
  }
}
